import { TransactionsReportTranslations } from "./transactions-report-pt-br";

export const TRANSACTIONS_REPORT_ES_MX: TransactionsReportTranslations = {
	title: "Lista de Transacciones",
	descriptionPlace: "Lista de todas las transacciones del período",
	descriptionEvent: "Lista de todas las transacciones del evento",
	filter: {
		title: "Filtrar",
		emptyFilter: "Haga clic para filtrar",
		modal: {
			inputPlaceholder: "Escriba aquí",
			selectPlaceholder: "Seleccione aquí",
			descriptionEnd: "para filtrar las transacciones",
		},
		modalOptions: {
			terminal: {
				label: "Terminal",
				title: "Número de terminal",
				description: "Ingrese el número de terminal",
			},
			clientDocument: {
				label: "Documento del cliente",
				title: "CPF o número de documento",
				description: "Ingrese el CPF o número de documento del cliente",
			},
			employee: {
				label: "Empleado",
				title: "Nombre del empleado",
				description: "Ingrese el nombre del empleado",
			},
			zigCode: {
				label: "ZigCode",
				description: "Ingrese el número del ZigCode",
			},
			paymentMethod: {
				label: "Forma de pago",
				description: "Seleccione una forma de pago",
			},
			transactionType: {
				label: "Tipo de transacción",
				description: "Seleccione un tipo de transacción",
			},
			bar: {
				label: "Filtro por bar",
				title: "Bar",
				description: "Seleccione un bar",
			},
		},
	},
	print: "Imprimir informe",
	table: {
		id: "ID",
		date: "Fecha",
		syncDate: "Fecha de sincronización",
		type: "Tipo",
		employee: "Empleado",
		terminal: "Serial del terminal",
		deviceId: "Device ID",
		zigCode: "ZigCard",
		bar: "Bar",
		client: "Cliente",
		product: "Producto",
		productCategory: "Categoría del producto",
		quantity: "Cantidad",
		source: "Source",
		paymentMethod: "Forma de pago",
		status: {
			canceled: "Cancelado",
			approved: "Aprobado",
			label: "Estado",
		},
		paidInOtherEvent: "Pagado en otro evento",
		document: "Documento",
		acquirer: "Adquirente",
		acquirerTransactionId: "ID de la transacción de adquirencia",
		cardBrand: "Marca de la Tarjeta",
		nsu: "NSU",
		nsuHost: "NSU Host",
		authorizationCode: "Código Autorización",
		bin: "Bin",
		service: "Servicio",
		value: "Valor",
		hawkerDocument: "Documento Ambulante",
		hawkerName: "Nombre Ambulante",
	},
	transactionTypes: {
		recharge: "Recarga",
		transaction: "Transacción",
		ficha: "Ficha",
		canceled: "Cancelada",
		refund: "Reembolso",
		digitalCashless: "Cashless digital",
	},
	maxSearchPeriod: "El período máximo de búsqueda es de 31 días",
	invalidPeriod: {
		beforeOpening: "La fecha inicial no puede ser anterior a la apertura del evento",
		afterClosing: "La fecha final no puede ser posterior al cierre del evento",
		afterCurrent: "La fecha final no puede ser posterior a la fecha actual",
	},
	exportExcel: {
		success: "Email con exportación enviado con éxito.",
		title: "Exportar informe",
		label: "Por favor, informe su email para envío de hoja de cálculo",
		error: "Ingrese un email válido",
		placeholder: "Ingrese su email",
	},
};
